import { type FC } from "react";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { ModalActualizarPago } from "../../modals/ModalActualizarPago/ModalActualizarPago";
import { ModalDeleteAdmin } from "../../modals/ModalDeleteAdmin/ModalDeleteAdmin";
import { ModalEditAdmin } from "../../modals/ModalEditAdmin/ModalEditAdmin";
import { useTabla } from "./tablaHooks";
import type { TablaProps } from "./tablaTypes";

const EMPTY_STATE_COLSPAN = 10;

export const Tabla: FC<TablaProps> = ({ datos, setUsersAdminData }) => {
  const {
    formatDate2,
    isActualizarPago,
    modalDelete,
    modalEdit,
    selectedAdmin,
    handleActualizarPago,
    handleDeleteClick,
    handleEditClick,
    setIsActualizarPago,
    setModalDelete,
    setModalEdit,
  } = useTabla();

  return (
    <>
      {isActualizarPago ? (
        <ModalActualizarPago
          setIsActualizarPago={setIsActualizarPago}
          selectedAdmin={selectedAdmin}
        />
      ) : null}

      {modalEdit ? (
        <ModalEditAdmin
          setModalEdit={setModalEdit}
          selectedAdmin={selectedAdmin}
          setUsersAdminData={setUsersAdminData}
        />
      ) : null}

      {modalDelete ? (
        <ModalDeleteAdmin
          setModalDelete={setModalDelete}
          selectedAdmin={selectedAdmin}
          setUsersAdminData={setUsersAdminData}
        />
      ) : null}

      <table className="min-w-full mt-8 bg-white">
        <thead>
          <tr className="bg-[#8131bd] text-white text-sm">
            <th className="border border-black w-6 px-2 py-1">#</th>
            <th className="border border-black min-w-fit px-2 py-1 uppercase">
              email
            </th>
            <th className="border border-black min-w-fit px-2 py-1 uppercase">
              nombre
            </th>
            <th className="border border-black min-w-fit px-2 py-1 uppercase whitespace-nowrap">
              rutas nombres
            </th>
            <th className="border border-black min-w-fit px-2 py-1 uppercase">
              rutas
            </th>
            <th className="border border-black min-w-fit px-2 py-1 uppercase whitespace-nowrap">
              ult. pago
            </th>
            <th className="border border-black min-w-fit px-2 py-1 uppercase whitespace-nowrap">
              prox. pago
            </th>
            <th className="border border-black min-w-fit px-2 py-1 uppercase whitespace-nowrap">
              actlzr. pago
            </th>
            <th className="border border-black w-10 px-2 py-1 uppercase">
              Editar
            </th>
            <th className="border border-black w-10 px-2 py-1 uppercase">
              Eliminar
            </th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(datos) && datos.length > 0 ? (
            datos.map((item, index) => (
              <tr
                key={item.uid}
                className={`${
                  index % 2 === 0 ? "bg-gray-300" : "bg-gray-100"
                } border border-black text-sm`}
              >
                <td className="border border-black text-center px-2 py-1">
                  {index + 1}
                </td>

                <td className="items-center border-black flex justify-center px-1 py-1">
                  {item.email}
                </td>

                <td className="border-black border text-center uppercase px-1 py-1 whitespace-nowrap">
                  {item.nombre}
                </td>

                <td className="border-black border text-center uppercase px-1 py-1">
                  {Array.isArray(item.nombresRutas) && item.nombresRutas.length > 0
                    ? item.nombresRutas.join(", ")
                    : "Sin rutas"}
                </td>

                <td className="border-black border text-center uppercase px-1 py-1">
                  {item.cantidadRutas}
                </td>

                <td className="border-black border text-center uppercase px-1 py-1">
                  {formatDate2(item.ultimoPago)}
                </td>

                <td className="border-black border text-center uppercase px-1 py-1">
                  {formatDate2(item.proximoPago)}
                </td>

                <td
                  onClick={() => handleActualizarPago(item)}
                  className="border-black border text-center uppercase px-1 py-1 underline cursor-pointer"
                >
                  Actualizar
                </td>

                <td className="border border-black w-10 text-center px-2 py-1">
                  <AiOutlineEdit
                    onClick={() => handleEditClick(item)}
                    className="cursor-pointer my-0 mx-auto"
                  />
                </td>
                <td className="border border-black w-10 px-2 py-1">
                  <AiOutlineDelete
                    className="cursor-pointer my-0 mx-auto"
                    onClick={() => handleDeleteClick(item)}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={EMPTY_STATE_COLSPAN}>No hay datos disponibles.</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};
